import * as types from './types';
import { cloneDeep, has } from 'lodash';

import { LUNCH_APPLICATION_WEBSITE_NAME } from 'Common/Constants/website';

const INITIAL_STATE = {
  fetching: false,
  fetchError: '',
  applicationData: [],
  filteredApplicationData: [],
  syncLoading: false,
  syncError: null,
  selectedFilter: -1,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.REVIEW_INCOMING_APPLICATIONS_FETCHING:
      return { ...state, fetching: payload };
    case types.REVIEW_INCOMING_APPLICATIONS_FETCH_ERROR:
      return { ...state, fetchError: payload };
    case types.REVIEW_INCOMING_APPLICATIONS_GET_APPLICATIONS:
      const data = cloneDeep(payload);
      return {
        ...state,
        applicationData: data,
        filteredApplicationData: data,
        selectedFilter: -1,
      };
    case types.REVIEW_INCOMING_APPLICATIONS_SET_SYNCLOADING:
      return {
        ...state,
        syncLoading: payload,
      };
    case types.REVIEW_INCOMING_APPLICATIONS_SET_FILTERED_DATA:
      //-1 is no filter selected
      if (payload === null || payload === -1) {
        return {
          ...state,
          filteredApplicationData: state.applicationData,
          selectedFilter: payload,
        };
      } else {
        return {
          ...state,
          filteredApplicationData: state.applicationData.filter(x =>
            x.Members.some(y => y.ReasonId === payload)
          ),
          selectedFilter: payload,
        };
      }
    case types.REVIEW_INCOMING_APPLICATIONS_SET_SYNC_ERROR:
      if (payload == null) {
        return {
          ...state,
          syncError: null,
        };
      }

      const msg = has(payload, 'response.data.Errors')
        ? payload.response.data.Errors[0].Title
        : `An error occurred while downloading applications from ${LUNCH_APPLICATION_WEBSITE_NAME}. Please try again.`;

      const err = {
        Title: 'Error',
        Message: msg,
      };

      return {
        ...state,
        syncError: err,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/state/grid/reducer.js